import { z } from 'zod';

export const userEntityRoleSchema = z.object({
  id: z.string().optional(),
  groupId: z.string().nullish(),
  group: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .optional(),
  companyId: z.string().nullish(),
  company: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .optional(),
  branchId: z.string().nullish(),
  branch: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .optional(),
  userId: z.string().nullish(),
  roleTypeId: z.string().nullish(),
  roleType: z
    .object({
      name: z.string(),
    })
    .optional(),
});

export type TUserEntityRoleSchema = z.infer<typeof userEntityRoleSchema>;
